import React, { useEffect, useState } from "react";
import { Rnd } from "react-rnd";
import * as css from "./style.module.scss";
import { graphql, useStaticQuery } from "gatsby";
import axios from "axios";

export const ChatWidget: React.FC = () => {
  const data = useStaticQuery(graphql`
    query chatWidgetData {
      site {
        siteMetadata {
          agent {
            baseUrl
            id
          }
        }
      }
    }
  `);
  const [profileAgent, setProfileAgent] = React.useState(null);
  const showChatWidget =
    // @ts-ignore
    window.location.pathname !== "/" && profileAgent?.salesmsg_widget === true;

  useEffect(() => {
    if (data.site.siteMetadata.agent.id) {
      (async () => {
        const response = await axios.get(
          `${data.site.siteMetadata.agent.baseUrl}/v1/platforms/${data.site.siteMetadata.agent.id}`,
          {
            headers: {
              Authorization: `Bearer ${process.env.GATSBY_PUBLIC_TOKEN}`,
            },
          }
        );

        window.sessionStorage.setItem(
          "agent-data",
          JSON.stringify(response.data)
        );

        setProfileAgent({ ...response.data });
      })();
    }
  }, [data?.site?.siteMetadata?.agent]);

  const [isOpen, setIsOpen] = useState(false);
  const [size, setSize] = useState({ width: 380, height: 460 });

  const toggleChat = () => setIsOpen((prev) => !prev);

  if (!showChatWidget) {
    return null;
  }

  return (
    <div className={css.chatContainer}>
      {isOpen && (
        <div className={css.chatWrapper}>
          <Rnd
            className={css.chatWindow}
            size={size}
            onResizeStop={(e, direction, ref) => {
              setSize({
                width: parseInt(ref.style.width, 10),
                height: parseInt(ref.style.height, 10),
              });
            }}
            minHeight={380}
            enableResizing={{
              top: true,
              right: true,
              bottom: false,
              left: false,
              topRight: false,
              bottomRight: false,
              bottomLeft: false,
              topLeft: false,
            }}
            position={{
              x: 0,
              y: -size.height,
            }}
            bounds={document.body}
            disableDragging
            resizeHandleComponent={{
              right: <div className={css.rightHandle} />,
              top: <div className={css.topHandle} />,
            }}
          >
            <div className={css.chatHeader}>
              <span>Salesmsg</span>
              <button className={css.closeButton} onClick={toggleChat}>
                ×
              </button>
            </div>
            <iframe
              className={css.iframe}
              src="https://app.salesmessage.com/widget-light/conversations"
              title="Chat"
            />
          </Rnd>
        </div>
      )}

      <button onClick={toggleChat} className={css.chatButton}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          version="1.1"
          id="Layer_1"
          x="0px"
          y="0px"
          width="100%"
          viewBox="0 0 256 256"
          enable-background="new 0 0 256 256"
          xmlSpace="preserve"
        >
          <path
            fill="transparent"
            opacity="1.000000"
            stroke="none"
            d=" M167.000000,257.000000   C111.333336,257.000000 56.166672,257.000000 1.000007,257.000000   C1.000005,171.666672 1.000005,86.333351 1.000003,1.000019   C86.333321,1.000013 171.666641,1.000013 257.000000,1.000006   C257.000000,86.333313 257.000000,171.666626 257.000000,256.999969   C227.166672,257.000000 197.333328,257.000000 167.000000,257.000000  M51.179607,161.724625   C55.769108,165.184143 60.358604,168.643677 65.289749,172.737564   C71.571266,174.846252 77.817131,177.070969 84.148811,179.016418   C87.492012,180.043655 89.305847,181.421310 89.115013,185.465286   C88.730576,193.611801 88.642357,201.814102 89.204544,209.939911   C89.391518,212.642441 91.350502,216.348541 93.573357,217.473206   C95.882469,218.641541 99.965393,218.104370 102.418716,216.757568   C105.935486,214.826950 108.794167,211.604050 111.728050,208.723343   C119.455345,201.136169 126.976067,193.335709 134.812164,185.864700   C136.393890,184.356674 138.995804,183.142120 141.139008,183.123398   C157.143341,182.983551 172.766571,180.691772 187.704086,174.911621   C198.890381,170.583023 207.058441,162.971710 212.182114,151.783813   C217.426056,140.333344 216.980286,128.130249 217.772964,116.178398   C218.321701,107.904739 217.222855,99.393349 215.870346,91.150612   C213.538971,76.942192 206.789917,65.600540 193.378311,58.664402   C178.768600,51.108627 163.053543,48.859074 147.036850,48.098770   C136.230484,47.585800 125.377174,48.159592 114.550110,47.961319   C100.140091,47.697430 86.213966,50.133263 72.715805,55.013607   C60.928020,59.275551 51.944813,66.493568 45.791107,77.925110   C39.974625,88.730194 41.299084,100.264542 40.224205,111.504791   C39.428490,119.825798 40.105438,128.413589 41.161945,136.751297   C42.278316,145.561462 44.351452,154.326584 51.179607,161.724625  z"
          />
          <path
            fill="#ffffff"
            opacity="1.000000"
            stroke="none"
            d=" M50.942238,161.095444   C44.351452,154.326584 42.278316,145.561462 41.161945,136.751297   C40.105438,128.413589 39.428490,119.825798 40.224205,111.504791   C41.299084,100.264542 39.974625,88.730194 45.791107,77.925110   C51.944813,66.493568 60.928020,59.275551 72.715805,55.013607   C86.213966,50.133263 100.140091,47.697430 114.550110,47.961319   C125.377174,48.159592 136.230484,47.585800 147.036850,48.098770   C163.053543,48.859074 178.768600,51.108627 193.378311,58.664402   C206.789917,65.600540 213.538971,76.942192 215.870346,91.150612   C217.222855,99.393349 218.321701,107.904739 217.772964,116.178398   C216.980286,128.130249 217.426056,140.333344 212.182114,151.783813   C207.058441,162.971710 198.890381,170.583023 187.704086,174.911621   C172.766571,180.691772 157.143341,182.983551 141.139008,183.123398   C138.995804,183.142120 136.393890,184.356674 134.812164,185.864700   C126.976067,193.335709 119.455345,201.136169 111.728050,208.723343   C108.794167,211.604050 105.935486,214.826950 102.418716,216.757568   C99.965393,218.104370 95.882469,218.641541 93.573357,217.473206   C91.350502,216.348541 89.391518,212.642441 89.204544,209.939911   C88.642357,201.814102 88.730576,193.611801 89.115013,185.465286   C89.305847,181.421310 87.492012,180.043655 84.148811,179.016418   C77.817131,177.070969 71.571266,174.846252 65.386330,172.183777   C69.505768,163.055099 73.376839,154.403076 77.665482,145.963257   C78.653549,144.018829 80.826134,142.123489 82.879791,141.375275   C89.478317,138.971191 99.403656,145.968857 100.741310,153.589905   C102.497108,163.593307 112.953239,170.595383 122.647591,168.259705   C132.701859,165.837311 139.602325,155.030350 135.891891,145.718796   C133.584869,139.929169 134.236145,135.398071 136.987961,130.377106   C138.738373,127.183319 140.186707,123.786362 141.412613,120.352737   C142.792908,116.486679 145.014282,114.242821 149.178482,112.995079   C155.941620,110.968620 159.880981,105.788475 160.917938,98.824821   C161.990692,91.620819 159.281021,85.722862 153.464752,81.414337   C147.249634,76.810364 139.037628,76.709717 132.449173,81.367554   C125.387360,86.360031 123.823837,93.834518 126.231674,101.388794   C128.175430,107.487106 126.805473,112.328949 124.276344,117.495026   C122.451660,121.222168 121.059319,125.172050 119.076065,128.805298   C118.225975,130.362640 116.569778,131.902618 114.927948,132.530930   C108.311577,135.062988 98.148415,128.817673 95.868393,121.933098   C94.414421,117.542809 92.300270,112.778610 89.043999,109.706299   C83.045982,104.047180 73.447342,104.449944 66.912933,109.360672   C60.443359,114.222649 58.331856,122.301346 61.168209,130.411331   C61.942165,132.624298 63.080658,135.501846 62.302258,137.329071   C58.864147,145.399689 54.787609,153.198318 50.942238,161.095444  z"
          />
          <path
            fill="#05acdf"
            opacity="1.000000"
            stroke="none"
            d=" M51.060921,161.410034   C54.787609,153.198318 58.864147,145.399689 62.302258,137.329071   C63.080658,135.501846 61.942165,132.624298 61.168209,130.411331   C58.331856,122.301346 60.443359,114.222649 66.912933,109.360672   C73.447342,104.449944 83.045982,104.047180 89.043999,109.706299   C92.300270,112.778610 94.414421,117.542809 95.868393,121.933098   C98.148415,128.817673 108.311577,135.062988 114.927948,132.530930   C116.569778,131.902618 118.225975,130.362640 119.076065,128.805298   C121.059319,125.172050 122.451660,121.222168 124.276344,117.495026   C126.805473,112.328949 128.175430,107.487106 126.231674,101.388794   C123.823837,93.834518 125.387360,86.360031 132.449173,81.367554   C139.037628,76.709717 147.249634,76.810364 153.464752,81.414337   C159.281021,85.722862 161.990692,91.620819 160.917938,98.824821   C159.880981,105.788475 155.941620,110.968620 149.178482,112.995079   C145.014282,114.242821 142.792908,116.486679 141.412613,120.352737   C140.186707,123.786362 138.738373,127.183319 136.987961,130.377106   C134.236145,135.398071 133.584869,139.929169 135.891891,145.718796   C139.602325,155.030350 132.701859,165.837311 122.647591,168.259705   C112.953239,170.595383 102.497108,163.593307 100.741310,153.589905   C99.403656,145.968857 89.478317,138.971191 82.879791,141.375275   C80.826134,142.123489 78.653549,144.018829 77.665482,145.963257   C73.376839,154.403076 69.505768,163.055099 65.215508,171.866577   C60.358604,168.643677 55.769108,165.184143 51.060921,161.410034  z"
          />
        </svg>
      </button>
    </div>
  );
};
